<template>
  <div>
    <v-data-table v-model="table.selected" :headers="table.headers" :server-items-length="getTotalItems()"
      :items="keywords ? keywords.data : []"
      :items-per-page="keywords && keywords.meta ? parseInt(keywords.meta.per_page) : 0" :page.sync="table.page"
      :options.sync="table.options" :sort-by.sync="table.sortBy" :sort-desc.sync="table.sortDesc" :loading="table.loading"
      hide-default-footer item-key="id" class="elevation-1 mt-4" @click:row="rowClick">
      <template v-slot:top>
        <v-row class="px-4 mx-0 pt-0">
          <v-col cols="12" md="3" sm="12" class="pa-0 ma-0">
            <v-select class="mr-md-2 my-2" v-model="table.filters.account" :error="accountError" :items="accounts.data"
              :loading="loadingAccounts" item-text="account_name" item-value="name" menu-props="auto" label="Conta"
              hide-details single-line outlined color="primary" dense clearable></v-select>
          </v-col>
          <v-col cols="12" md="5" sm="12" class="pa-0 ma-0">
            <v-text-field class=" my-2" v-model="table.filters.search" append-icon="mdi-magnify" clearable
              label="Procurar" single-line hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>

        <v-expand-transition>
          <div v-show="moreFilters">
            <v-row class="px-4 mt-5 mb-3">
              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <date-picker
                  label="De"
                  solo
                  hide-details
                  clearable
                  noIcon
                  dense
                  :max="todayDate"
                  v-model="table.filters.date_start"
                  v-on:change="changeSchedulingDateStart"
                />
              </v-col>

              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <date-picker
                  label="Até"
                  solo
                  hide-details
                  clearable
                  noIcon
                  dense
                  :min="table.filters.date_start"
                  :max="max_date_end"
                  :disabled="!table.filters.date_start"
                  v-model="table.filters.date_end"
                  v-on:change="changeSchedulingDateEnd"
                />
              </v-col>

              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <v-btn :loading="loadingReport" color="info" @click="keywordsExport">
                  <v-icon left>mdi-download</v-icon>
                  Exportar
                </v-btn>
              </v-col>

            </v-row>
          </div>
        </v-expand-transition>

        <v-row class="px-4 mx-0 mt-5 mb-3">
          <v-btn small outlined color="primary" @click="moreFilters = !moreFilters" class="mr-2">
            <v-icon left>{{ moreFilters ? 'mdi-filter-minus-outline' : 'mdi-filter-plus-outline' }}</v-icon>
            Relatório
          </v-btn>

          <v-btn v-if="canCreateTag" small color="primary" outlined @click="openCreate" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Criar nova
          </v-btn>

          <keyword-group-modal v-if="canGroupTag" class="mr-2" :on-save="grouped" title="Agrupar tags" />

        </v-row>
      </template>

      <template v-slot:footer>
        <v-pagination class="mb-4" v-model="table.page"
         :length="keywords && keywords.meta ? keywords.meta.last_page : 0"></v-pagination>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <keyword-detail-modal :open="openModalDetail"
      :title="action === 'CREATE' ? 'Criar tag' : (canUpdateTag ? 'Editar tag' : 'Tag')" :data="keywordSelected"
      :action-type="action" :on-close="closeDetail" :on-save="saved" :on-delete="deleted" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import { handleResponseError } from '@/api/handleError'
import * as permissionsNames from '@/constants/permissions'
import hasPermission from '@/helpers/hasPermission'
import KeywordDetailModal from '@/views/Keywords/KeywordDetailModal'
import KeywordGroupModal from '@/views/Keywords/KeywordGroupModal'
import DatePicker from '@/components/DatePicker'

export default {
  name: 'Keywords',
  computed: {
    ...mapState({
      keywords: state => state.keywords.all,
      accounts: state => state.accounts.all,
      exportKeywords: state => state.keywords.exportKeywords,
    }),
    _() {
      return _
    },
    canCreateTag() {
      return hasPermission(permissionsNames.CAN_STORE_TAGS)
    },
    canGroupTag() {
      return hasPermission(permissionsNames.CAN_GROUP_TAGS)
    },
    canUpdateTag() {
      return hasPermission(permissionsNames.CAN_UPDATE_TAGS)
    },
    todayDate() {
      return new Date().toISOString().split('T')[0]
    },
    ninetyDaysAgoDate() {
      const today = new Date()
      today.setDate(today.getDate() - 90)
      return today.toISOString().split('T')[0]
    },
  },
  components: {
    KeywordDetailModal,
    KeywordGroupModal,
    DatePicker,
  },
  methods: {
    fetchKeywords: async function () {
      this.table.loading = true
      await this.$store.dispatch('keywords/getKeywords', {
        account: this.table.filters.account,
        search: this.table.filters.search,
        page: this.page,
        order: this.sortDesc ? 'desc' : 'asc',
        sort: this.sortBy,
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as tags.')
        this.showNotification(message, 'red darken-2')
        this.table.loading = false
      })
      this.table.loading = false
    },
    fetchAccounts: async function () {
      this.loadingAccounts = true
      this.accountError = false
      await this.$store.dispatch('accounts/getAccounts', { limit: 0 }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as contas.')
        this.showNotification(message, 'red darken-2')
        this.loadingAccounts = false
        this.accountError = true
      })
      this.loadingAccounts = false
      this.accountError = false
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getTotalItems: function () {
      return this.keywords && this.keywords.meta ? parseInt(this.keywords.meta.total) : 0
    },
    openDetail: function () {
      this.openModalDetail = true
    },
    closeDetail: function () {
      this.openModalDetail = false
    },
    rowClick: function (keyword) {
      this.keywordSelected = keyword
      this.action = 'EDIT'
      this.openDetail()
    },
    saved: function () {
      this.showNotification(`Palavra-chave ${this.action === 'CREATE' ? 'criada' : 'atualizada'}!`, 'green')
      this.fetchKeywords()
      this.closeDetail()
    },
    grouped: function () {
      this.showNotification(`Tags agrupadas`, 'green')
      this.fetchKeywords()
    },
    deleted: function () {
      this.showNotification('Palavra-chave excluída!', 'green')
      this.fetchKeywords()
      this.closeDetail()
    },
    openCreate: function () {
      this.action = 'CREATE'
      this.keywordSelected = {}
      this.openDetail()
    },
    async keywordsExport() {
      if (!this.table.filters.account) {
        this.showNotification('Selecione uma conta', 'red darken-2')
        return
      }
      if (!this.table.filters.date_start) {
        this.showNotification('Selecione a data inicial', 'red darken-2')
        return
      }
      if (!this.table.filters.date_end) {
        this.showNotification('Selecione a data final', 'red darken-2')
        return
      }
      const filters = {
        account: this.table.filters.account,
        date_start: this.table.filters.date_start,
        date_end: this.table.filters.date_end,
      }
      this.loadingReport = true
      await this.$store.dispatch('keywords/exportKeywords', filters).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao gerar o relatório.')
        this.showNotification(message, 'red darken-2')
        this.loadingReport = false
      })
      this.loadingReport = false
    },
    changeSchedulingDateStart(date) {
      this.table.filters.date_start = date
    },
    changeSchedulingDateEnd(date) {
      this.table.filters.date_end = date
    },
  },
  watch: {
    'table.options': function (options) {
      let sortBy = options.sortBy[0]
      const sortDesc = options.sortDesc[0]
      if ((sortBy || '').includes('formatted')) {
        const s = sortBy.split('_formatted')
        sortBy = s[0]
      }

      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.page = options.page
      this.limit = 10
      this.fetchKeywords()
    },
    'table.filters.search': function () {
      clearTimeout(this.timeoutSearch)
      this.timeoutSearch = setTimeout(this.fetchKeywords, 300)
    },
    'table.filters.account': function () {
      this.fetchKeywords()
    },
    'table.filters.date_start': function (date_start) {
      const today = new Date()
      let max_date = new Date(date_start)
      max_date.setDate(max_date.getDate() + 90)
      
      if(max_date.getTime() > today.getTime()) {
        max_date = today
      }

      this.max_date_end = max_date.toISOString().split('T')[0]
      this.table.filters.date_end = max_date.toISOString().split('T')[0]
    },
    exportKeywords(blob, oldBlob) {
      if (blob && blob !== oldBlob) {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'keywords.xlsx')
        document.body.appendChild(link)
        link.click()
      }
    },
  },
  created() {
    this.fetchKeywords()
    this.fetchAccounts()
  },
  data: () => ({
    action: 'EDIT',
    openModalDetail: false,
    keywordSelected: {},
    timeoutSearch: null,
    accountError: '',
    loadingAccounts: false,
    loadingReport: false,
    sortBy: '',
    sortDesc: '',
    limit: 15,
    page: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    moreFilters: false,
    max_date_end: new Date().toISOString().split('T')[0],
    table: {
      loading: false,
      filters: {
        account: '',
        search: '',
        date_start: '',
        date_end: '',
      },
      headers: [
        { text: 'Nome', value: 'name', align: 'start' },
        { text: 'Conta', value: 'account_name', sortable: false }
      ],
      page: 1,
      sortBy: null,
      sortDesc: false,
      options: {},
    },
  }),
}
</script>